import { styled } from '@linaria/react';

import Aside from '@/components/Aside';
import Paragraph from '@/components/Paragraph';
import TextLink from '@/components/Link/TextLink';
import InlineCode from '@/components/InlineCode';
import VideoGif from '@/components/VideoGif';

function LinkedTimelineUnsupported() {
  return (
    <Wrapper
      type="warning"
      title={
        <>
          Your browser doesn’t support <code>timeline-scope</code>.
        </>
      }
    >
      <Paragraph>
        This playground makes use of the <code>timeline-scope</code>{' '}
        property, which is not yet available in your browser. I’ve
        applied a polyfill for the Animation Timeline API, but sadly,
        this polyfill doesn’t support linked timelines.
      </Paragraph>
      <VideoGif
        src="/images/scroll-driven-animations/linked-timelines-demo.mp4"
        alt="A paragraph scrolls through the viewport. When it enters, a yellow square on the left starts fading in. As it exits, the square fades out. The yellow square never moves."
        width={1412 / 2}
        height={706 / 2}
      />
    </Wrapper>
  );
}

const Wrapper = styled(Aside)`
  @supports (timeline-scope: --example-scope) {
    display: none;
  }
`;

export default LinkedTimelineUnsupported;
